import { render, staticRenderFns } from "./configCompetitorCreateOne.vue?vue&type=template&id=0e50432a&scoped=true"
import script from "./configCompetitorCreateOne.vue?vue&type=script&lang=js"
export * from "./configCompetitorCreateOne.vue?vue&type=script&lang=js"
import style0 from "./configCompetitorCreateOne.vue?vue&type=style&index=0&id=0e50432a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50432a",
  null
  
)

export default component.exports